import { useTranslation } from 'react-i18next';
import { ProfileCard } from '../components/ProfileCard';
import { ChangePasswordCard } from '../components/ChangePasswordCard';
import { PreferencesCard } from '../components/PreferencesCard';
import { BillingDetailsCard } from '../components/BillingDetailsCard';

export function MyAccountPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-5" data-testid="my-account-page">
      <header>
        <h1 className="text-xl font-bold tracking-tight text-[var(--foreground)]">{t('account.title')}</h1>
        <p className="mt-1 text-sm text-[var(--foreground-muted)]">{t('account.subtitle')}</p>
      </header>

      <div className="grid gap-5 md:grid-cols-2">
        <ProfileCard />
        <ChangePasswordCard />
        <PreferencesCard />
        <BillingDetailsCard />
      </div>
    </div>
  );
}
